import { Box, SystemProps, css } from "@storyofams/react-ui";
import { defineMessages, FormattedMessage } from "react-intl";

import { Modal, ProductSlider, Heading } from "../../components";
import { Button } from "../common/Button";
import { useShopify } from "../../context";
import {
  ProductByHandleQuery,
  ProductRecommendationsQuery,
} from "../../lib/shopify/sdk";
import { shopifyToIntlPrice } from "../../lib/shopify/utils";

const messages = defineMessages({
  addToCart: "Bestel nu!",
  addedToCart: "is toegevoegd aan je winkelmand",
  keepShopping: "Verder winkelen",
  pay: "Afrekenen",
  perfectCombinationWith: "De perfecte combinatie met",
});

interface Props {
  product: ProductByHandleQuery["productByHandle"];
  productRecommendations: ProductRecommendationsQuery["productRecommendations"];
  isOpen: boolean;
  bundleTitle?: string;
  close(): void;
}

export const UpsellModal = ({
  product,
  productRecommendations,
  isOpen,
  bundleTitle,
  close,
}: Props & SystemProps) => {
  const { cart } = useShopify();
  return (
    <Modal isOpen={isOpen} close={close}>
      <Box bg="grey100" px={[2, 3]} pt={[6.5, 5]} pb={[4]} position="relative">
        <Heading variant="h4" as="h2" fontSize={[2.25, 3]} mb={[4, 5]}>
          {bundleTitle || product?.title} <FormattedMessage {...messages.addedToCart} />
        </Heading>

        <Box
          display="grid"
          gridTemplateColumns={["1fr", "repeat(2, 1fr)"]}
          gridColumnGap={2}
          gridRowGap={2}
        >
          <Button
            variant="secondary"
            onClick={close}
            px={[5, 2]}
            css={css({
              "&:not(:disabled)": {
                "&:hover, &:focus, &:active": { px: [5, 2] },
              },
            })}
          >
            <FormattedMessage {...messages.keepShopping} />
          </Button>

          {cart?.cost?.totalAmount && (
            <Button
              variant="primary"
              href="/cart"
              px={[5, 2]}
              css={css({
                "&:not(:disabled)": {
                  "&:hover, &:focus, &:active": { px: [5, 2] },
                },
              })}
            >
              <FormattedMessage {...messages.pay} /> --{" "}
              {shopifyToIntlPrice(cart?.cost?.totalAmount)}
            </Button>
          )}
        </Box>
      </Box>

      <Box px={[2, 3]} py={[4, 5]} overflow={"hidden"}>
        <Heading variant="h5" as="h3" mb={[5, 3]} fontSize={[2.5, 2.25]}>
          <FormattedMessage {...messages.perfectCombinationWith} />{" "}
          {bundleTitle || product?.title}
        </Heading>

        <ProductSlider
          centered={false}
          products={productRecommendations as any}
          onClick={close}
          withAddToCartButton
          isUpsell
          small
        />
      </Box>
    </Modal>
  );
};
